import { Percent } from "@mui/icons-material";
import {
  Button,
  Grid,
  Stack,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { IconCurrencyRupee, IconShare, IconUserCircle } from "@tabler/icons";
import { useMemo, useState } from "react";
import { LineWave } from "react-loader-spinner";
import { useNavigate, useParams } from "react-router";
import { axiosInstance } from "src/api/axios";
import PageContainer from "src/components/container/PageContainer";
import TabPanel from "../../components/tabpanel";

const ProductPage = () => {
  const theme = useTheme();
  const lgUp = useMediaQuery((theme) => theme.breakpoints.up("lg"));
  const [product, setProduct] = useState([]);
  // const lgDown = useMediaQuery((theme) => theme.breakpoints.down('lg'));
  const [productImage, setProductImage] = useState("");
  const navigate = useNavigate();

  const [loading, setLoading] = useState(true);
  const { productId } = useParams();

  useMemo(() => {
    axiosInstance.get(`/product/${productId}`).then((response) => {
      setProduct(response.data);
      setLoading(false);
      if (response.data.images.length) {
        setProductImage(() => {
          let image =
            response.data.images[response.data.images.length > 1 ? 1 : 0];

          return image;
        });
      }
    });
  }, []);
  if (loading) {
    return (
      <Grid container>
        <Grid item xs={12}>
          <Stack
            justifyContent={"center"}
            alignItems={"center"}
            height={"60vh"}
          >
            <LineWave height={545} width={250} style={{ margin: "auto" }} />
          </Stack>
        </Grid>
      </Grid>
    );
  } else {
    return (
      <PageContainer
        title={`${product.title || "Offers Page"} | Earnpati`}
        description="this is Earnpati Products page"
        style={{ minWidth: "95vw", p: 0, m: 0 }}
      >
        <Grid container spacing={3} sx={{ paddingLeft: lgUp ? "" : "32px" }}>
          <Grid
            item
            lg={6}
            xs={12}
            sx={{ padding: lgUp ? "0 24px" : "0", ml: lgUp ? "0" : "-1rem" }}
          >
            {productImage ? (
              <img
                src={productImage}
                alt={`Earnpati Offers of ${product.title} `}
                style={{
                  objectFit: "cover",
                  objectPosition: "left",
                  width: "100%",
                  maxWidth: lgUp ? "100%" : "85vw",
                  height: lgUp ? 280 : "auto",
                  maxHeight: lgUp ? "" : "50vh",
                }}
              />
            ) : null}
          </Grid>
          <Grid container lg={6} xs={12} gridRow={6} spacing={lgUp ? 3 : 1}>
            <Grid item sx={{ marginTop: 2.5 }} xs={12}>
              <Typography variant="h4">{product.title}</Typography>
            </Grid>
            <Grid item xs={12}>
              <Typography variant="subtitle2">{product.subtitle}</Typography>
            </Grid>
            <Grid item xs={12}>
              <Typography>
                <span style={{ fontWeight: "bold" }}>
                  {product.earntype || "Earn Upto"}:{" "}
                </span>{" "}
                {!product?.isPercentage ? (
                  <>
                    <IconCurrencyRupee style={{ marginBottom: -7 }} />
                    <span style={{ fontWeight: "bolder" }}>
                      {product.earnUpto}
                    </span>
                  </>
                ) : (
                  <>
                    <span style={{ fontWeight: "bolder" }}>
                      {product.earnUpto}
                    </span>
                    <Percent style={{ marginBottom: -7 }} />
                  </>
                )}
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <Stack
                spacing={1}
                sx={{
                  borderRadius: 3,
                  width: lgUp ? "90%" : "95%",
                  background: theme.palette.earnpati.info,
                  padding: " 10px 15px",
                }}
                justifyContent={"space-between"}
              >
                <Stack direction={"row"} spacing={1}>
                  <Typography sx={{ fontWeight: "bolder" }}>
                    Lead Tracking time:
                  </Typography>
                  <p>
                    {" " + product.trackingTime
                      ? product.trackingTime
                      : "1 week"}
                  </p>
                </Stack>
                <Stack direction={"row"} spacing={1}>
                  <Typography sx={{ fontWeight: "bolder" }}>
                    Payment Cycle:
                  </Typography>
                  <p style={{ textAlign: "center" }}>
                    {product.payment || "Same day after tracking"}
                  </p>
                </Stack>
              </Stack>
            </Grid>
            <Grid
              item
              xs={12}
              justifyContent={"space-around"}
              spacing={2}
              sx={{ width: { lg: "92%", xs: "100%" } }}
            >
              <Button
                sx={{
                  borderColor: ["Paused", "Stopped"].includes(product.status)
                    ? theme.palette.grey[500]
                    : theme.palette.earnpati.main,
                  borderWidth: "2px",
                  minWidth: lgUp ? "45%" : "95%",
                  // minWidth: lgUp ? '40%' : '45%',
                  // bgcolor: theme.palette.earnpati.main,
                  color: ["Paused", "Stopped"].includes(product.status)
                    ? theme.palette.grey[500]
                    : theme.palette.earnpati.main,
                  mt: "2%",
                  ml: "5px",
                  "&:hover": {
                    borderWidth: "2px",
                    borderColor: ["Paused", "Stopped"].includes(product.status)
                      ? theme.palette.grey[500]
                      : theme.palette.earnpati.success,
                    cursor: "pointer",
                  },
                }}
                variant={"outlined"}
                size="large"
                onClick={() => {
                  navigate(
                    ["Paused", "Stopped"].includes(product.status)
                      ? "#"
                      : `/join/${productId}`
                  );
                }}
              >
                {["Paused", "Stopped"].includes(product.status) ? (
                  "Paused"
                ) : (
                  <>
                    <span style={{ marginRight: "7px" }}>Add Customer</span>{" "}
                    <IconUserCircle />
                  </>
                )}
              </Button>
              <Button
                sx={{
                  bgcolor: ["Paused", "Stopped"].includes(product.status)
                    ? theme.palette.grey[500]
                    : theme.palette.earnpati.main,
                  borderWidth: "12px",
                  minWidth: lgUp ? "40%" : "95%",
                  minHeight: "44px",
                  mt: "2%",
                  ml: { lg: 3, xs: "5px" },
                  "&:hover": {
                    backgroundColor: ["Paused", "Stopped"].includes(
                      product.status
                    )
                      ? theme.palette.grey[500]
                      : theme.palette.earnpati.success,
                    cursor: "pointer",
                  },
                }}
                variant="contained"
                size="large"
                onClick={() => {
                  navigate(
                    ["Paused", "Stopped"].includes(product.status)
                      ? "#"
                      : `/join/${productId}/?direct=true`
                  );
                }}
              >
                <span style={{ marginRight: "7px" }}>Share Link</span>
                <IconShare />
              </Button>
            </Grid>
          </Grid>
          <Grid item xs={12}>
            <Stack sx={{ minWidth: lgUp ? "" : "95vw" }}>
              <TabPanel products={product} theme={theme} lgUp={lgUp} />
            </Stack>
          </Grid>
        </Grid>
      </PageContainer>
    );
  }
};

export default ProductPage;
